import { useEffect, useState } from "react";

const KEY = "casa-haya-cookie-consent";

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (val) => {
    localStorage.setItem(KEY, val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner" role="dialog" aria-live="polite">
      <div className="flex-1 min-w-[220px]">
        <p className="font-serif text-base mb-1" style={{ color: "var(--gold)" }}>
          A small note on cookies
        </p>
        <p className="text-xs leading-relaxed" style={{ color: "rgba(250,247,242,0.85)" }}>
          We use essential cookies to make this site work and optional ones for
          analytics — to understand how guests discover Casa Haya. You're
          in control.
        </p>
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <button
          data-testid="cookie-essential"
          onClick={() => accept("essential")}
          className="px-4 py-2 rounded-full text-xs uppercase tracking-[0.18em]"
          style={{
            color: "var(--cream)",
            border: "1px solid rgba(250,247,242,0.35)",
            background: "transparent",
          }}
        >
          Essential only
        </button>
        <button
          data-testid="cookie-accept"
          onClick={() => accept("all")}
          className="px-4 py-2 rounded-full text-xs uppercase tracking-[0.18em] font-medium"
          style={{
            background: "var(--gold)",
            color: "var(--brown)",
            border: "1px solid var(--gold)",
          }}
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
